import { makeStyles } from '@material-ui/core'

export const useTableStyles = makeStyles((theme) => ({
  table: {
    backgroundColor: 'white',
  },
  titleHeaderCell: {
    fontWeight: 'bold',
    width: '50%',
  },
  indented: {
    paddingLeft: theme.spacing(5),
  },
  editableCell: {
    cursor: 'pointer',
  },
  versionHeaderCell: {
    width: '20%',
    fontWeight: 'bold',
  },
}))
